<template>
  <div>
    <a-card :bordered="false">
      <a-form layout="inline" :form="form" @submit="handleSearch" style="margin-bottom: 16px">
        <a-form-item label="账期">
          <a-month-picker
            v-decorator="['carrier_month']"
            placeholder="请选择年月"
            style="width: 140px"
          />
        </a-form-item>
        <a-form-item label="客户">
          <a-select
            show-search
            allow-clear
            :filter-option="false"
            :value="filterTopAgentId"
            placeholder="搜索一级客户"
            style="width: 200px"
            @search="searchFilterAgents"
            @change="changeFilterAgent"
          >
            <a-select-option v-for="item in filterAgentOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="客户套餐">
          <a-select
            show-search
            allow-clear
            option-filter-prop="children"
            :disabled="!filterTopAgentId"
            :loading="loadingProductOptions"
            :value="filterProductId"
            :placeholder="filterTopAgentId ? '全部套餐' : '请先选择客户'"
            style="width: 220px"
            @change="changeFilterProduct"
          >
            <a-select-option v-for="item in productOptions" :key="item.id" :value="item.product_id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="ICCID">
          <a-input v-decorator="['iccid']" allow-clear style="width: 200px" />
        </a-form-item>
        <a-form-item label="来源">
          <a-select v-decorator="['source']" allow-clear style="width: 140px">
            <a-select-option value="monthly_job">月度批跑</a-select-option>
            <a-select-option value="purchase">采购入账</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">查询</a-button>
          <a-button
            v-if="isShowMenu('sim_card_month_costs/rerun')"
            style="margin-left: 8px"
            html-type="button"
            @click="handleRecalculate"
          >重算</a-button>
        </a-form-item>
      </a-form>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="showDetail(record)">明细</a>
        </span>
      </a-table>
    </a-card>

    <a-modal
      title="成本分项明细"
      :visible="detailVisible"
      :footer="null"
      width="720px"
      @cancel="detailVisible = false"
    >
      <a-descriptions bordered size="small" :column="2" style="margin-bottom: 16px">
        <a-descriptions-item label="ICCID">{{ detail.iccid }}</a-descriptions-item>
        <a-descriptions-item label="账期月">{{ detail.carrier_month }}</a-descriptions-item>
        <a-descriptions-item label="套餐">{{ detail.carrier_product_name }}</a-descriptions-item>
        <a-descriptions-item label="合计">{{ detail.cost_amount }}</a-descriptions-item>
      </a-descriptions>
      <a-table
        :columns="lineColumns"
        :data-source="detail.lines || []"
        :pagination="false"
        row-key="id"
        size="small"
      />
    </a-modal>
  </div>
</template>

<script>
import { findSimCardMonthCosts, findSimCardMonthCostDetail, rerunSimCardMonthCost } from '@/api/sim_card_month_cost'
import { findAgentOptions } from '@/api/agent'
import { findAgentsProductsOptions } from '@/api/agents_product'
import { hasPermission } from '@/utils/permission'
import { formatYearMonth } from '@/utils/time'

export default {
  name: 'SimCardMonthCosts',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      tableData: [],
      query: {},
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      columns: [
        { title: '账期月', dataIndex: 'carrier_month' },
        { title: 'ICCID', dataIndex: 'iccid' },
        { title: '号码', dataIndex: 'phone_number' },
        { title: '运营商套餐', dataIndex: 'carrier_product_name' },
        { title: '客户', dataIndex: 'agent_name' },
        { title: '来源', dataIndex: 'source_display' },
        { title: '成本合计', dataIndex: 'cost_amount' },
        { title: '操作', scopedSlots: { customRender: 'action' }}
      ],
      lineColumns: [
        { title: '分项', dataIndex: 'formula_display' },
        { title: '计量', dataIndex: 'meter' },
        { title: '用量', dataIndex: 'quantity' },
        { title: '单价', dataIndex: 'unit_price' },
        { title: '金额', dataIndex: 'cost_amount' }
      ],
      detailVisible: false,
      detail: {},
      filterTopAgentId: undefined,
      filterAgentName: '',
      filterAgentOptions: [],
      filterProductId: undefined,
      filterProductName: '',
      productOptions: [],
      loadingProductOptions: false,
      agentSearchKeyword: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    fetchData() {
      this.loading = true
      const params = Object.assign({}, this.query, {
        page: this.pagination.current,
        per_page: this.pagination.pageSize
      })
      findSimCardMonthCosts(params).then((res) => {
        this.tableData = res.data || []
        if (res.pagination) {
          this.pagination.total = res.pagination.total_count || res.pagination.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    currentFilters() {
      const values = this.form.getFieldsValue()
      const query = {
        carrier_month: formatYearMonth(values.carrier_month),
        iccid: values.iccid,
        source: values.source
      }
      if (this.filterTopAgentId) {
        query.top_agent_id = this.filterTopAgentId
      }
      if (this.filterProductId) {
        query.product_id = this.filterProductId
      }
      return query
    },
    handleSearch(e) {
      e.preventDefault()
      this.query = this.currentFilters()
      this.pagination.current = 1
      this.fetchData()
    },
    searchFilterAgents(name) {
      const keyword = this.$lodash.trim(name)
      this.agentSearchKeyword = keyword
      if (!keyword) {
        this.filterAgentOptions = []
        return
      }
      findAgentOptions({ name: keyword }).then((res) => {
        if (res.code === 0 && this.agentSearchKeyword === keyword) {
          this.filterAgentOptions = res.data || []
        }
      })
    },
    changeFilterAgent(value) {
      this.filterProductId = undefined
      this.filterProductName = ''
      this.productOptions = []
      if (value === undefined || value === null || value === '') {
        this.filterTopAgentId = undefined
        this.filterAgentName = ''
        return
      }
      this.filterTopAgentId = value
      const found = this.filterAgentOptions.find((item) => item.id === value)
      this.filterAgentName = found ? found.name : ''
      this.fetchProductOptions(value)
    },
    changeFilterProduct(value) {
      if (value === undefined || value === null || value === '') {
        this.filterProductId = undefined
        this.filterProductName = ''
        return
      }
      this.filterProductId = value
      const found = this.productOptions.find((item) => item.product_id === value)
      this.filterProductName = found ? found.name : ''
    },
    fetchProductOptions(agentId) {
      this.loadingProductOptions = true
      findAgentsProductsOptions({ agent_id: agentId, include_ineffective: true }).then((res) => {
        if (res.code === 0 && this.filterTopAgentId === agentId) {
          this.productOptions = res.data || []
        }
        this.loadingProductOptions = false
      }).catch(() => {
        this.loadingProductOptions = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchData()
    },
    showDetail(record) {
      findSimCardMonthCostDetail(record.id).then((res) => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    handleRecalculate() {
      const filters = this.currentFilters()
      if (!filters.carrier_month) {
        this.$message.warning('请选择账期')
        return
      }
      const monthLabel = this.form.getFieldValue('carrier_month').format('YYYY-MM')
      const parts = [monthLabel]
      if (this.filterTopAgentId) {
        parts.push(`客户「${this.filterAgentName || this.filterTopAgentId}」`)
      }
      if (this.filterProductId) {
        parts.push(`套餐「${this.filterProductName || this.filterProductId}」`)
      }
      if (filters.iccid) {
        parts.push(`ICCID ${filters.iccid}`)
      }
      const downstream = this.filterTopAgentId ? '含已划到下级的卡。' : ''
      const that = this
      this.$confirm({
        title: `确认按 ${parts.join('、')} 重算月度成本？${downstream}`,
        onOk() {
          const payload = { carrier_month: filters.carrier_month }
          if (filters.top_agent_id) {
            payload.top_agent_id = filters.top_agent_id
          }
          if (filters.product_id) {
            payload.product_id = filters.product_id
          }
          if (filters.iccid) {
            payload.iccid = filters.iccid
          }
          return rerunSimCardMonthCost(payload).then((res) => {
            that.$message.success(res.message || '已触发')
            that.query = filters
            that.pagination.current = 1
            that.fetchData()
          })
        }
      })
    }
  }
}
</script>
